import { IGetEntregaObrasParametrosUseCase } from "../../../presentation/useCases/read/get_entrega_obras_parametros_use_case";
import { EntregaObraParametros } from "../../models/entrega_obra_parametros";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * GetEntregaObrasParametrosUseCase
 */

export class GetEntregaObrasParametrosUseCase implements IGetEntregaObrasParametrosUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(idEntregaObra: number): Promise<EntregaObraParametros> {
    return await this.repository.getEntregaObraParametros(idEntregaObra);
  }
}
